
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".67","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.999 16V4M15.993 15.964L5.61 22","stroke":"#fff"}}),_c('path',{attrs:{"d":"M4.2 18.2A11.612 11.612 0 014 16a11.988 11.988 0 018-11.312v9l-7.8 4.513z","stroke":"#56BFC7"}}),_c('path',{attrs:{"d":"M16 4A12 12 0 115.65 22.076","stroke":"#fff"}})])])
          )
        }
      }
    